import React from 'react'


const Teaser = ({
  status,
  title,
  view_node,
  field_region,
  start,
  end,
  ...props
 }) => (
  <article>
              <strong>
                <img
                //Review completed
                src={status === 'open' ? '/modules/custom/linz_map_snapshot/assets/linz-marker-teal.svg' : '/modules/custom/linz_map_snapshot/assets/linz-marker-gray.svg'}
                width={20}
                height={20}
                alt={status} />
                <a href={view_node}>{title}</a>
              </strong>
              <dl>
                {field_region && (
                  <>
                    <dt>District</dt>
                    <dd>{field_region}</dd>
                  </>
                )}
                {start && (
                  <>
                    <dt>Opened on</dt>
                    <dd>{new Intl.DateTimeFormat('en-NZ', { dateStyle: 'long' }).format(start)}</dd>
                  </>
                )}
                {end && (
                  <>
                    <dt>Closes on</dt>
                    <dd>{new Intl.DateTimeFormat('en-NZ', { dateStyle: 'long' }).format(end)}</dd>
                  </>
                )}

              </dl>
            </article>
)

export default Teaser;
